import { Injectable } from '@angular/core';

/**
 * Aqui definimos las reglas globales que vamos a utilizar para definir el sistema responsive
 * */
@Injectable()
export class ResponsiveService {
  public readonly _isDesktop: boolean;
  private readonly hasTouchScreen: boolean;

  constructor() {
    if ('maxTouchPoints' in window.navigator) {
      this.hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ('msMaxTouchPoints' in navigator) {
      this.hasTouchScreen = navigator.msMaxTouchPoints > 0;
    } else if ('orientation' in window) {
      this.hasTouchScreen = true;
    } else {
      // Como ultimo recurso usamos user agent sniffing
      const UA = window['navigator'].userAgent.toString();
      this.hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
    this._isDesktop = !this.hasTouchScreen;
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/responsive.service.ts